import { render, staticRenderFns } from "./GenericNotification.vue?vue&type=template&id=5e572941&"
import script from "./GenericNotification.vue?vue&type=script&lang=js&"
export * from "./GenericNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports